import { IGetControleResiduoByIdUseCase } from "../../../presentation/useCases/read/get_controle_residuo_by_id_use_case";
import { GetControleResiduoByIdRequestModel, GetControleResiduoByIdResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetControleResiduoByIdUseCase
 */

export class GetControleResiduoByIdUseCase implements IGetControleResiduoByIdUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async getControleResiduoById(model: GetControleResiduoByIdRequestModel): Promise<GetControleResiduoByIdResponseModel> {
    return await this.repository.getControleResiduoById(model);
  }
}
